import { queryOptions } from '@tanstack/vue-query'

export const useGetLuxolaUserAccountOptions = () => {
  const { $luxolaUserAccountRepository } = useNuxtApp()
  return queryOptions({
    queryKey: userAccountQueryKey,
    queryFn: async () => await $luxolaUserAccountRepository.index(),
  })
}
